import React from "react";
import classNames from "classnames";
import styles from "./style.module.scss";

export interface CustomNotificationsProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  author?: string;
  timeAgo?: string;
  unread?: boolean;
  showBorder?: boolean;
  onClick?: () => void;
  className?: string;
}

const CustomNotifications = ({
  icon,
  title,
  description,
  author,
  timeAgo,
  unread = false,
  showBorder = true,
  onClick,
  className,
}: CustomNotificationsProps) => {
  return (
    <button
      type="button"
      className={classNames(
        styles.wrapper,
        showBorder && styles.leftBorder,
        className,
      )}
      onClick={onClick}
    >
      {unread && <span className={styles.greenDot} aria-hidden="true" />}

      <div className={styles.iconWrap} aria-hidden="true">
        {icon ? icon : <div className={styles.defaultIcon} />}
      </div>

      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {description && <div className={styles.description}>{description}</div>}

        <div className={styles.meta}>
          {author && <h6 className={styles.author}>{author}</h6>}
          {author && timeAgo && <span className={styles.separator}>•</span>}
          {timeAgo && <span className={styles.time}>{timeAgo}</span>}
        </div>
      </div>
    </button>
  );
};

export default CustomNotifications;
